import {
  GET_BOOKLETS_REQUEST,
  CREATE_BOOKLET_REQUEST,
  UPDATE_BOOKLET_REQUEST,
  GET_BOOKLET_REQUEST,
  GET_BOOKLET,
  GET_BOOKLET_TRANSACTIONS_REQUEST,
  GET_BOOKLET_TRANSACTIONS,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST,
  GET_BOOKLET_TRANSACTION_GROUPS,
} from '../types/booklets'

export function getBooklets(payload) {
  return {
    type: GET_BOOKLETS_REQUEST,
    payload,
  }
}

export function createBooklet(payload) {
  return {
    type: CREATE_BOOKLET_REQUEST,
    payload,
  }
}

export function updateBooklet(payload) {
  return {
    type: UPDATE_BOOKLET_REQUEST,
    payload,
  }
}

export function getBooklet(payload) {
  return {
    type: GET_BOOKLET_REQUEST,
    payload,
  }
}

export function setBooklet(payload) {
  return {
    type: GET_BOOKLET,
    payload,
  }
}

export function getBookletTransactions(payload) {
  return {
    type: GET_BOOKLET_TRANSACTIONS_REQUEST,
    payload,
  }
}

export function setBookletTransactions(payload) {
  return {
    type: GET_BOOKLET_TRANSACTIONS,
    payload,
  }
}

export function getBookletTransactionGroups(payload) {
  return {
    type: GET_BOOKLET_TRANSACTION_GROUPS_REQUEST,
    payload,
  }
}

export function setBookletTransactionGroups(payload) {
  return {
    type: GET_BOOKLET_TRANSACTION_GROUPS,
    payload,
  }
}
